import styles from "./TaxData.module.scss";

const TaxData: React.FC = () => {
  return <div className={styles.body}>Tax Data</div>;
};

export default TaxData;
